import { Box } from '@chakra-ui/react';
import { CoreBlock } from '../../types';

interface CoreQuoteProps {
  block: CoreBlock & {
    attrs: CoreBlock['attrs'];
  };
  renderBlocks: (block: CoreBlock, i: number) => JSX.Element;
}

const CoreQuote: React.FC<CoreQuoteProps> = ({ block, renderBlocks }) => {
  const { className } = block.attrs || {};
  return (
    <blockquote className={className}>
      <Box fontStyle="italic" mb={4} sx={{ p: { fontSize: '2xl' } }}>
        {block.innerBlocks?.map(renderBlocks)}
      </Box>
    </blockquote>
  );
};
export default CoreQuote;
